import { Button, EmptyState } from '@mgrvtechgroup/admin-ds';
import { TriangleAlertIcon } from 'lucide-react';
import { Link } from 'react-router';

/** 라우트 렌더 실패 화면 — 무엇이 안 됐고 다음에 무엇을 하면 되는지 알려 준다(HTR 리뷰: 다음 행동을 알려 주는 오류). */
export function RouteErrorPage() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-6">
      <h1 className="title-lg text-center">화면을 불러오지 못했습니다</h1>
      <EmptyState
        icon={TriangleAlertIcon}
        title="문제가 발생했습니다"
        description="새로고침해 주세요. 문제가 계속되면 운영 담당자에게 문의해 주세요."
        className="h-auto min-h-0 flex-none"
      />
      <div className="flex flex-wrap items-center justify-center gap-2">
        <Button
          onClick={() => {
            window.location.reload();
          }}
        >
          새로고침
        </Button>
        {/* 새로고침해도 같은 화면에서 실패하면 막다른 길이 되지 않도록 지점 목록으로 빠져나갈 길을 둔다. */}
        <Button nativeButton={false} role="link" variant="outline" render={<Link to="/" />}>
          지점 목록으로
        </Button>
      </div>
    </div>
  );
}
